import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const returnIntegrationErrorZod = z.object({
  message: z.string(),
  integrationProvider: z.string(),
  nonRetryable: z.boolean(),
  errorCode: z.string(),
});

export const createRmaForReturn = {
  name: "createRmaForReturn" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: returnIntegrationErrorZod.array().or(z.null()),
};
